export function getSurveyQuestion(surveyNumber, caseNumber, vuex) {
  const aCase = vuex.getters.getCaseByCaseNumber(caseNumber);
  if (surveyNumber === 1) {
    return aCase.surveyQuestion1;
  } else {
    return aCase.surveyQuestion2;
  }
}

export function generateSurveyDescriptionString(vuex) {
  const scenario = vuex.getters.getScenarioInCurrentLocale

  if (!scenario.survey_minimum_value_label || !scenario.survey_maximum_value_label) {
    return "";
  } else {
    return "1=" + scenario.survey_minimum_value_label + ", " + vuex.state.main.game.surveyScale + "=" + scenario.survey_maximum_value_label
  }
}

export function convertPhotoToAmazonURL(url) {
  // URL may contain domain or not, depending on how it was saved

  let path = url;

  try {
    const urlObj = new URL(url);
    path = urlObj.pathname;
  } catch (e) {
  }

  return process.env.VUE_APP_S3_PHOTOS_DOMAIN + path;
}
